import { Controller } from "stimulus"
import Rails from '@rails/ujs';

export default class extends Controller {
  connect() {
    const mainCategorySelector = document.querySelector('[data-selector="maincategory"]');
    const subCategorySelector = document.querySelector('[data-selector="subcategory"]');
    const url = "/pa/relevant_tags.json";
    subCategorySelector && subCategorySelector.addEventListener('change', () => {
      const selectedMainCategories = [...mainCategorySelector.options].filter(option => option.selected).map(option => option.value)
      const selectedSubCategories = [...subCategorySelector.options].filter(option => option.selected).map(option => option.value)
      const selectedCategories = selectedMainCategories.concat(selectedSubCategories);
      const selectedTags = [...this.element.options].filter(option => option.selected).map(option => option.value)

      // send the selected categories so we get the possible tags
      // we will traverse the tree to get all possible tags
      let searchString = ["category_ids[]="];
      // concat the empty category array with any selected options
      searchString = searchString.concat(selectedCategories.map(id => `category_ids[]=${id}`))
      // create the query params and encode
      const idParams = encodeURI(searchString.join('&'));
      // const idParams = encodeURI(subSelectedCategories.map(id => `category_ids[]=${id}`).join('&'));

      Rails.ajax({
        type: 'GET',
        url: `${url}?${idParams}`, // someurl?param1=1&param2=2
        dataType: 'json',
        success: (response) => {
          // for tags we are using then name as both value and text
          const values = Object.keys(response).map(key => ({
            value: response[key], text: response[key]
          }))
          if (values.length > 0) {
            // if we get any tags then update with the new tags
            // and restore the previously selected tags
            this.element.slim.setData(values)
            this.element.slim.set(selectedTags)
            this.element.slim.enable()
          } else {
            // no tags were returned!
            // disable the select too
            this.element.slim.setData([])
            this.element.slim.disable()
          }
        }
      })
    })
  }
}
